export default "__VITE_ASSET__BaWhh6wo__"